<template>
	<div class="flex gap-2">
		<app-input
			v-model="term"
			name="search"
			placeholder="Enter a contract or collection number" />

		<app-button icon="fa-magnifying-glass" @click="search"> Search </app-button>
	</div>

	<div v-if="loading" class="w-full flex justify-center py-4">
		<app-loader size="large" />
	</div>

	<div v-else>
		<div v-for="(group, key) in files" :key class="mt-4" data-testid="file-group">
			<h3 class="font-semibold text-mabey-950">{{ _.upperFirst(String(key)) }}s</h3>

			<div class="px-3 mt-3">
				<div
					v-for="(file, index) in group"
					:key="index"
					data-testid="file-row"
					class="even:bg-gray-100 flex items-center justify-between px-4 py-3">
					<img :src="file.path" :alt="`${file.link_type} ${file.type}`" width="150px" />

					<app-button theme="info" icon="fa-external-link" :to="file.path">
						Download
					</app-button>
				</div>
			</div>
		</div>
	</div>
</template>

<script lang="ts" setup>
	import JourneyService from '@/services/journey'
	import useToaster from '@/stores/toaster'
	import { ref } from 'vue'
	import _ from 'lodash'

	const api = new JourneyService()
	const toaster = useToaster()

	const loading = ref(false)
	const term = ref('')
	const files = ref()

	function search() {
		loading.value = true
		api.searchJourneyFiles(term.value)
			.then((response) => {
				files.value = response.data.data
			})
			.catch((error) => {
				console.error(error)
				toaster.error({
					text: 'Error occurred with file search'
				})
			})
			.finally(() => {
				loading.value = false
			})
	}
</script>
